import { safeboxClient } from 'myNet'

const ROUTE = '/v1/group'

interface ApiResponse<T = any> {
  code: number
  message: string
  data?: T
}

interface ErrorWithCode extends Error {
  code: number
}

interface GetRequest {
  id: string
}

const GroupService = {
  get: async ({ id }: GetRequest): Promise<ApiResponse> => {
    const response = await safeboxClient.get(`${ROUTE}/${id}/user_list`)
    const { code, message } = response.data
    if (code !== 200) {
      const err = new Error(message) as ErrorWithCode
      err.code = code
      throw err
    }
    return response.data
  },
}

export default GroupService
